export default __webpack_public_path__ + "menu-voucher-smop-icon.abf39144f9aab2136ecb1110365397bd.svg";